import { useState, useEffect } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { ICONS } from "@/assets";
import { ColumnMasterAnggota } from "../../../library/FormColumn";

import { API, URL } from "@/config/api";
import { ConfigProvider, Space, Table, Button, message, Skeleton } from "antd";

import ButtonExportPDF from "@/components/ButtonExportPDF";
import ButtonExportExcel from "@/components/ButtonExportExcel";

import jsPDF from "jspdf";
import "jspdf-autotable";

import ModalComponent from "../account/ModalComponent";
// import column from "./ColumnForm";

import { createStyles } from "antd-style";
import dayjs from "dayjs";
const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const MasterAnggota = () => {
  const { styles } = useStyle();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [editData, setEditData] = useState(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [initialValues, setInitialValues] = useState({
    noAnggota: "",
    noSimpanan: "",
    nameAnggota: "",
    tglMasuk: "",
    alamat: "",
    nopol: "",
    isActive: true,
    keterangan: "",
    simpananPokok: 0,
    simpananWajib: 0,
  });

  const hadleModalOpen = (type, record) => {
    if (type === "add") {
      setModalMode(type);
      setEditData(null);
      setIsModalOpen(true);
    } else {
      setModalMode(type);
      setEditData(record);
      setIsModalOpen(true);
    }
  };

  const handleAdd = async (data) => {
    try {
      console.log("submitted new data: ", data);
      await API.post(URL.MASTER_ANGGOTA + "/add", data);
      await getData();
      message.success("Data successfully added!");
    } catch (error) {
      console.error(error);
      message.error("Data unsuccessfully added!");
    }
  };

  const handleEdit = async (data) => {
    try {
      await API.put(URL.MASTER_ANGGOTA + "/update/" + data.id, data);
      await getData();
    } catch (error) {
      console.error(error);
      message.error("Data unsuccessfully updated!");
    }
  };

  const handleDelete = async (id) => {
    try {
      await API.delete(URL.MASTER_ANGGOTA + "/" + id);
      await getData();
      message.success("Data successfully deleted!");
    } catch (error) {
      console.error(error);
      message.error("Data unsuccessfully deleted!");
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      const response = await API.get(URL.MASTER_ANGGOTA);
      setData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      message.error("Data failed to fetch!");
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const actionColumn = {
    title: "Action",
    key: "action",
    fixed: "right",

    render: (_, record) => (
      <Space size="middle">
        <button onClick={() => hadleModalOpen("view", record)}>
          <img src={ICONS.FaDetail} alt="View" />
        </button>

        <button onClick={() => hadleModalOpen("edit", record)}>
          <img src={ICONS.FaEdit} alt="Edit" />
        </button>

        <button onClick={() => hadleModalOpen("delete", record.id)}>
          <img src={ICONS.FaTrash} alt="Delete" />
        </button>
      </Space>
    ),
  };

  const extendedColumn = [...ColumnMasterAnggota.columns, actionColumn];

  const exportPDF = () => {
    if (data != "") {
      const doc = new jsPDF();

      const headers = ColumnMasterAnggota.columns.map((col) => col.title);

      const body = data.map((row) =>
        ColumnMasterAnggota.columns.map((col) => row[col.dataIndex])
      );

      doc.autoTable({
        head: [headers],
        body: body,
      });

      // Simpan file PDF
      doc.save("Master Anggota.pdf");
    } else {
      message.error("Data is empty");
      console.log("error");
    }
  };

  const exportToExcel = async () => {
    const date = dayjs(); // Get current date
    const getMonthName = date.format("MMM");
    const formattedDate = date.format("MMM-YY");

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(getMonthName);

    // Tambahkan header utama
    worksheet.mergeCells("A1:J1");
    const header1 = worksheet.getCell("A1");
    header1.value = "MASTER ANGGOTA";
    header1.font = { bold: true, size: 24 };
    header1.alignment = { horizontal: "center", vertical: "middle" };
    header1.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };
    header1.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.mergeCells("A2:J2");
    const header3 = worksheet.getCell("A2");
    header3.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ffffff" }, // white background
    };

    // Tambahkan sub-header dengan tanggal
    worksheet.mergeCells("A3:J3");
    const header2 = worksheet.getCell("A3");
    header2.value = formattedDate;
    header2.font = { bold: true, size: 32 };
    header2.alignment = { horizontal: "center", vertical: "middle" };
    header2.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };
    header2.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.getRow(4).height = 25;

    // Tambahkan header kolom
    const headers = [
      "NO. ANGGOTA",
      "NO. SIMPANAN",
      "NAMA ANGGOTA",
      "TANGGAL MASUK",
      "ALAMAT",
      "NOPOL",
      "STATUS",
      "KETERANGAN",
      "SIMPANAN POKOK",
      "SIMPANAN WAJIB",
    ];
    headers.forEach((header, index) => {
      const cell = worksheet.getCell(4, index + 1); // Baris ke-3 untuk header kolom
      cell.value = header;
      cell.font = { bold: false, size: 12 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBDD7EE" }, // Light blue background
      };
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };
    });

    data.forEach((item, rowIndex) => {
      const row = worksheet.getRow(5 + rowIndex); // Data dimulai dari baris ke-4
      row.getCell(1).value = item.noAnggota;
      row.getCell(2).value = item.noSimpanan;
      row.getCell(3).value = item.nameAnggota;
      row.getCell(4).value = item.tglMasuk;
      row.getCell(5).value = item.alamat;
      row.getCell(6).value = item.nopol;
      row.getCell(7).value = item.isActive ? "AKTIF" : "NON AKTIF";
      row.getCell(8).value = item.keterangan;
      row.getCell(9).value = item.simpananPokok;
      row.getCell(10).value = item.simpananWajib;

      row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(4).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(6).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(7).alignment = { horizontal: "center", vertical: "middle" };

      // Format untuk nilai angka (Debet, Kredit, Saldo)
      row.getCell(9).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
      row.getCell(10).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";

      const borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      // Loop through cells 1 to 5 and apply the border style
      for (let i = 1; i <= headers.length; i++) {
        row.getCell(i).border = borderStyle;
      }
    });

    // Atur lebar kolom
    worksheet.columns = [
      { width: 20 },
      { width: 20 },
      { width: 30 },
      { width: 20 },
      { width: 40 },
      { width: 15 },
      { width: 15 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
    ];

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Laporan Master Anggota.xlsx`);
  };

  return (
    <div>
      <h1 className="text-4xl font-semibold mb-8">Master Anggota</h1>

      <div className="flex justify-between">
        <Button
          type="primary"
          size="large"
          onClick={() => hadleModalOpen("add", null)}
          className=" bg-primary text-white py-2 px-4 rounded-md mb-4"
        >
          Tambah Data
        </Button>

        <div className="flex gap-4">
          <ButtonExportPDF onClick={exportPDF} />
          <ButtonExportExcel onClick={exportToExcel} />
        </div>
      </div>

      {loading ? (
        <Skeleton active />
      ) : (
        <ConfigProvider
          theme={{
            components: {
              Table: {
                colorPrimary: "#0164A2",
                headerColor: "#fff",
                headerBg: "#0164A2",
                headerBorderRadius: 6,
                algorithm: true,
                // borderColor: "#000",
              },
              Pagination: {
                colorPrimary: "#0164A2",
                colorPrimaryHover: "#0164A2",
                colorPrimaryBorder: "#0164A2",
                algorithm: true,
              },
            },
          }}
        >
          <Table
            className={`${styles.customTable} ${data == "" && `shadow-md`}`}
            columns={extendedColumn}
            dataSource={data}
            size="middle"
            scroll={{
              x: "max-content",
              // y: 55 * 5,
            }}
          />
        </ConfigProvider>
      )}

      <ModalComponent
        isVisible={isModalOpen}
        onClose={() => (setIsModalOpen(false), setModalMode(null))}
        mode={modalMode}
        initData={editData}
        handleAdd={handleAdd}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        column={ColumnMasterAnggota.formValidation}
        initialValues={initialValues}
      />
    </div>
  );
};

export default MasterAnggota;
